import React, { useContext, useState } from 'react';
import { systemCode } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { PvrContext } from '../../data/pvr/PvrConf';
import { ShopContext } from '../../data/shop/ShopConf';
import { getConfiguration } from '../../data/utils';
import { getLabel } from '../../InitData';
import BookedBetPopup from './BookBetPopup';
import SimpleCssCounter from '../../data/SimpleCssCounter';

function BetslipButtons(props) {
	const betslipContext = useContext(BetslipContext) ;
    const shopContext = useContext(ShopContext);
	const pvrContext = useContext(PvrContext);
    const configuration = getConfiguration();
    const [showPopup, setShowPopup] = useState(false);

	const couponKey = props.couponKey;
    const playButtonState = betslipContext.getPlayButtonState();
    const cartMessage = betslipContext.getCartMessage();
    function clearBetslip() {
    	betslipContext.clearBetslip(couponKey);
    }
    
    function changeButtonState(buttonState) {
    	betslipContext.setPlayButtonState(buttonState);
    }
    
    
    function purchase() {
    	const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket && window.setPaperCaseEmpty;
    	if(!askForPaper){
    		betslipContext.purchase();    		
    	}		 
    	else{
			  const protocol = betslipContext.isVirtual? 'PSV' : 'PSQF';
			  window.addBodyShadow();
			  window.XSocket.askForPaper(protocol, (data) => {
				  window.removeBodyShadow();
				  if(data.body === 'OK'){
					  betslipContext.purchase();
					  window.setPaperCaseEmpty(false);
				  }
				  else {
					  window.setPaperCaseEmpty(true, data.body);
				  }
			  });
		  }
    }
    
    
    function resetCart() {
    	changeButtonState('play');
    }
    
    const bookingMode = systemCode.includes('_PRENOTATORE');

    if(systemCode.includes('-BOOKER') && window.appConfig && (typeof window.appConfig.ONLINE_BOOKER == 'undefined')) {
        window.appConfig.ONLINE_BOOKER = true;
    }

    function reserveTicket() {
        if (bookingMode) {
            setShowPopup(true);
        } else {
            betslipContext.reserveTicket();
        }
    }
    
    function testDepositAndPurchasePvr() {
    	pvrContext.testDepositPvr(true, () =>{
    		changeButtonState('confirm');
    	});
    }
    
    const purchaseTooltipPart1 = getLabel('pvr.check_ticket_sale_part1');
    const purchaseTooltipPart2 = getLabel('pvr.check_ticket_sale_part2');
    const purchaseTooltipEnabled = purchaseTooltipPart1 && 
    							   purchaseTooltipPart1.length > 0 &&
    							   purchaseTooltipPart2 &&
    							   purchaseTooltipPart2.length > 0;
    									  
    const depositPurchaseTooltipPart1 = getLabel('pvr.check_charge_and_ticket_sale_message_part1');
    const depositPurchaseTooltipPart2 = getLabel('pvr.check_charge_and_ticket_sale_message_part2');
    const depositPurchaseTooltipEnabled = depositPurchaseTooltipPart1 && 
    									  depositPurchaseTooltipPart1.length > 0 &&
    									  depositPurchaseTooltipPart2 &&
    									  depositPurchaseTooltipPart2.length > 0;
    
    
    let showReservationButton = false;
    
    if (!shopContext.enabled) {
    	showReservationButton = pvrContext.pvrSectionEnabled == false;
    } 
    else {
    	if (shopContext.operator) {
    		// checking if this terminal is enabled to show the button
    		showReservationButton = shopContext.isAllowed(window.FUNZIONI_TERMINALE['BOOKING_KEY_ENABLED_FOR_TERMINAL']);
    	} else {
    		showReservationButton = true;
    	}
    }
    showReservationButton = showReservationButton &&  (playButtonState === 'play' || playButtonState === 'again'); //&& !betslipContext.isBetBuilder();
    
    function AcceptanceExpiring(props){
    	
    	if(props.seconds){
	    	return <>
	    		<div className="acceptanceOfferExpirationSeconds"> 
					{getLabel('acceptance.expiring_in')}
				</div>
	    		<SimpleCssCounter classAnchor={"acceptanceOfferExpirationSeconds"}  seconds={props.seconds} />
	    	</>
    	}
		return null;
    }
    
    return (
        <>
            {showPopup &&
                <BookedBetPopup dismiss={() => setShowPopup(false)} />
            }
            {cartMessage != null && <div className={"betslip-message " + cartMessage.type}>
                    <div> {cartMessage.message} </div>
                    <AcceptanceExpiring seconds={cartMessage.acceptanceOfferExpirationSeconds} />
             </div>

            }            
            <div className="bottoni-schedina">
                {(playButtonState === 'play' || playButtonState === 'again') &&
                    <button onClick={() => clearBetslip()} className="bottone bg-rosso bianco maiuscolo">{getLabel('carrello.empty_cart')}</button>
                }
                {/*BUTTON "RESERVATION" */}
                {showReservationButton &&
                    <button onClick={() => reserveTicket() } className="bottone bg-arancio bianco maiuscolo">{getLabel('carrello.reserve_ticket')}</button> 
                }
                {playButtonState === 'confirm' &&
                    <button onClick={() => resetCart() } className="bottone bg-arancio bianco maiuscolo">{getLabel('carrello.go_back')}</button> 
                }
                {/*BUTTON "PLAY" */}
                {pvrContext.pvrSectionEnabled ?
                    <>
                        {pvrContext.testDepositAndPurchaseUserEnabled && (
                            <button onClick={() => testDepositAndPurchasePvr()} className="bottone bg-blu bianco maiuscolo pvrTooltipContainer"> 
                                {getLabel('pvr.check_charge_and_ticket_sale_part1')} <br /> {getLabel('pvr.check_charge_and_ticket_sale_part2')}
                                {depositPurchaseTooltipEnabled &&
                                    <div  style={{left:'-50%'}} className="pvrTooltipContent">
                                        {getLabel('pvr.check_charge_and_ticket_sale_message_part1')}
                                        <span className="grassetto maiuscolo">
                                        {getLabel('pvr.check_charge_and_ticket_sale_message_part2')}
                                        </span>
                                    </div>
                                }
                            </button> 
                        )}
                        {(playButtonState === 'play' || playButtonState === 'again') && pvrContext.testPurchaseUserEnabled && (
                            <button onClick={() => changeButtonState('confirm')} className="bottone bg-verde bianco maiuscolo pvrTooltipContainer"> 
                                {getLabel('pvr.check_ticket_sale_part1')}
                                {getLabel('pvr.check_ticket_sale_part1').length > 0 && (<br /> )}
                                {getLabel('pvr.check_ticket_sale_part2')} 
                                {purchaseTooltipEnabled && 
                                    <div style={{left:'-150%'}} className="pvrTooltipContent">
                                        {getLabel('pvr.check_ticket_sale_message_part1')}
                                        <span className="grassetto maiuscolo">
                                        {getLabel('pvr.check_ticket_sale_message_part2')}
                                        </span>
                                    </div>
                                }
                            </button>
                        )}
                        {playButtonState === 'confirm' && (
                            <button onClick={() => purchase()} className="bottone bg-blu bianco maiuscolo">{getLabel('carrello.ok')}</button> 
                        )}
                    </>
                    :
                    <>
                        {!bookingMode && !window.appConfig.SHOP_BOOKER && !window.appConfig.ONLINE_BOOKER && (playButtonState === 'play' || playButtonState === 'again') && (
                            <button onClick={() => changeButtonState('confirm')} className="bottone bg-verde bianco maiuscolo">{playButtonState === 'play'? getLabel('carrello.button.gioca') : getLabel('carrello.button.again')}</button> 
                        )}
                        {playButtonState === 'confirm' && (
                            <button onClick={() => purchase()} className="bottone bg-blu bianco maiuscolo">{getLabel('carrello.ok')}</button> 
                        )}
                    </>
                }
            </div>
        </>
    );
}

export default BetslipButtons;